import FinanceAdapter from './base';

export default class DailySummary extends FinanceAdapter {
  modelNamePlural = 'dailySummaries';
}
